import type { ReactNode } from "react";
import { motion, useReducedMotion } from "motion/react";

type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  className?: string;
};

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  className = "",
}: SectionHeadingProps) {
  const reduce = useReducedMotion();
  const alignment =
    align === "center" ? "text-center mx-auto" : "text-start";

  const fadeUp = reduce
    ? { initial: false }
    : {
        initial: { opacity: 0, y: 20 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-80px" },
        transition: { duration: 0.5, ease: "easeOut" as const },
      };

  return (
    <motion.header
      {...fadeUp}
      className={`max-w-3xl ${alignment} ${className}`}
    >
      {eyebrow ? (
        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.25em] text-brand-500">
          {eyebrow}
        </p>
      ) : null}
      <h2 className="section-heading text-text-heading">{title}</h2>
      {description ? (
        <p className="mt-5 text-lg text-text-muted">{description}</p>
      ) : null}
    </motion.header>
  );
}
